import { ValueFormatterParams } from "ag-grid-community";
import React, { useCallback, useMemo, useRef, useState } from "react";
import PlusButtonIcon from "../../../../assets/images/PlusButtonIcon.svg";
import Grid from "../../../../components/Grid";
import { ColumnDef } from "../../../../components/Grid/model/Grid";
import ModalDelete from "../../../../components/ModalDelete";
import Loading from "../../../../core/common/Loading";
import { useModal } from "../../../../hooks/ModalContext";
import api from "../../../../services/api";
import Create from "./Create";
import { IGrupo } from "./Create/types/types";
import Info from "./Info";
import Can from "../../../../components/Can";

const ListGrupos: React.FC = () => {

  const columns = useMemo<ColumnDef[]>(() => [
    {
      field: "subsistema",
      headerName: "Subsistema",
      flex: 1,
      filter: true,
      sortable: true,
    },
    {
      field: "nome",
      headerName: "Grupo",
      flex: 1,
      filter: true,
      sortable: true,
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
  ], []);

  const [isRemove, setIsRemove] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRow, setSelectedRows] = useState<IGrupo>();
  const [isView, setIsView] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const gridRef = useRef<any>();

  const { isModalOpen, closeModal, openModal } = useModal();

  const onDelete = useCallback(async (rowId?: number) => {
    try {
      setLoading(true);
      const body = {
        id_grupo: rowId,
      };

      await api.post("/deletar/grupos", body);

      setLoading(false);

      setIsRemove(false);

      gridRef.current?.refresh();
    } catch {
      setLoading(false);
    }
  }, []);

  return (
    <>
      {isModalOpen && (
        <Create
          isView={isView}
          isEdit={isEdit}
          selectedRow={selectedRow}
          onClear={() => {
            closeModal();
            setIsEdit(false);
            setIsView(false);
            setSelectedRows(undefined);
          }}
          onConfirm={() => {
            closeModal();
            gridRef.current?.refresh();
          }}
        />
      )}

      <Loading loading={loading} />

      {isRemove && (
        <ModalDelete
          onCancel={() => setIsRemove(!isRemove)}
          onConfirm={() => onDelete(selectedRow?.id_grupo)}
          row={`Grupo - ${selectedRow?.nome}`}
        />
      )}
      {isView && (
        <Info
          data={selectedRow}
          title="Conhecer - Grupo"
          onClose={() => setIsView(!isView)}
        />
      )}

      <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
        <div className="flex items-center justify-between w-full mb-3">
          <div>
            <h1 className="text-2xl text-[#000000] font-bold">
              Grupos
            </h1>
          </div>
          <div className="mr-14">
            <Can acao="SALVAR">
            <button
              className="flex items-center justify-center h-12 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full"
              onClick={() => {
                setIsView(false);
                setIsEdit(false);
                setSelectedRows(undefined);
                openModal();
              }}
              id="btnCreate"
            >
              Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
            </button>
            </Can>
          </div>
        </div>
        <div className="flex w-full">
          <Grid
            ref={gridRef}
            columns={columns}
            filters={[]}
            pagination
            perPage={10}
            path="/listar/grupos"
            status={[]}
            defaultSortField="id_grupo"
            onDelete={(data: any) => {
              setIsRemove(!isRemove);
              setSelectedRows(data);
            }}
            onView={(data: any) => {
              setSelectedRows(data);
              setIsView(!isView);
            }}
            onUpdate={(data: any) => {
              setSelectedRows(data);
              setIsEdit(true);
              setIsView(false);
              openModal();
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ListGrupos;


